import { ProductDumpApiContext } from 'components/common-form/contexts/ProductDumpContext';
import { useUserNotification } from 'hooks/useUserNotification';
import { useCallback, useContext, useState } from 'react';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { downloadZip } from 'utils/documents/downloadDocument';

export interface DownloadProductDumpMainApi {
  downloadProductDumpMain(pricingId: string): Observable<Blob>;
}

export const useProductDumpMain = (
  errorMessage = 'An error occurred while downloading product dump main. Please contact the support team if it persists.',
) => {
  const userNotification = useUserNotification();
  const productDumpApi = useContext(ProductDumpApiContext)!;
  const [isProductDumpMainDownloading, setIsProductDumpMainDownloading] = useState(false);

  const downloadProductDumpMain = useCallback(
    (pricingId: string) => {
      setIsProductDumpMainDownloading(true);
      const dump$: Observable<Blob> = productDumpApi.downloadProductDumpMain(pricingId).pipe(
        finalize(() => {
          setIsProductDumpMainDownloading(false);
        }),
      );
      dump$.subscribe({
        next(blob: Blob) {
          downloadZip(blob, `${pricingId}_productDump_main.zip`);
        },
        error() {
          userNotification.error({ title: { id: 'toast.export' }, content: [errorMessage] });
        },
      });
    },
    [productDumpApi, userNotification, errorMessage],
  );

  return {
    isProductDumpMainDownloading,
    downloadProductDumpMain,
  };
};
